import React from "react";

const ComingSoon = ({ title = "Coming Soon", message = "This feature is currently under development." }) => {
  return (
    <div className="card">
      <div className="card-body">
        <div className="d-flex flex-column align-items-center justify-content-center py-5">
          <div className="text-center mb-4">
            <i className="bx bx-time-five" style={{ fontSize: "80px", color: "#6c757d" }} />
          </div>
          <h3 className="mb-3">{title}</h3>
          <p className="text-muted mb-4">{message}</p>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;